import {
  AccountAvailableGamesFilterBuffPlay,
  AccountFilterBuffPlay,
  AccountTransactionsFilterBuffPlay,
  AccountTransactionsTypeBuffPlay,
} from "../store/account-transactions-BuffPlay.store"
import { apiCall } from "../../../api-calls/api-call"

export const getAccountTransactionBuffPlay = async(
  accountId: string,
  filter: AccountTransactionsFilterBuffPlay,
  limit: number,
  page: number,
): Promise<AccountTransactionsTypeBuffPlay[]> => {
  const query: {
    accountId: string;
    types?: number[];
    limit?: number;
    page?: number;
    gameId?: number[];
    createdAtOrder?: string;
    startDate?: string;
    endDate?: string;
  } = { limit, accountId, page }
  if (filter && filter.types) query.types = filter.types
  if (filter && filter.gameId) query.gameId = filter.gameId
  if (filter && filter.createdAtOrder) query.createdAtOrder = filter.createdAtOrder
  if (filter && filter.startDate) query.startDate = filter.startDate
  if (filter && filter.endDate) query.endDate = filter.endDate

  return apiCall({
    method: "GET",
    path: "buff-play/transactions/all",
    query,
  })
}

export const getAccountDetailsByIdBuffPlay = async(accountId: string) => {
  return apiCall({
    method: "GET",
    path: `buff-play/accounts/${accountId}`,
  })
}

export const getGamesBuffPlay = async(page: number, limit: number, source?: string) => {
  return apiCall({
    method: "GET",
    path: "buff-play/games",
    query: { page, limit, ...(source && { gameSource: source }) },
  })
}

export const getAnalyticsBuffPlay = async(accountId: string, page: number, limit: number, filter: AccountFilterBuffPlay) => {
  const query: {
    accountId: string;
    page?: number;
    limit?: number;
    eventName?: string;
    startDate?: string;
    endDate?: string;
  } = { limit, accountId, page }
  if (filter && filter.eventName) query.eventName = filter.eventName
  if (filter && filter.startDate) query.startDate = filter.startDate
  if (filter && filter.endDate) query.endDate = filter.endDate

  return apiCall({
    method: "GET",
    path: "analytics/events",
    query,
  })
}

export const getSecurityLogsBuffPlay = async(accountId: string, page: number, limit: number, filter: AccountTransactionsFilterBuffPlay) => {
  const query: {
    accountId: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  } = { limit, accountId, page }
  if (filter && filter.startDate) query.startDate = filter.startDate
  if (filter && filter.endDate) query.endDate = filter.endDate

  return apiCall({
    method: "GET",
    path: "security-logs",
    query,
  })
}

export const getTransactionsBuffPlayTypes = async() => {
  return apiCall({
    method: "GET",
    path: "buff-play/transactions/types",
  })
}

export const createTransactionBuffPlay = async(data: any) => {
  return apiCall({
    method: "POST",
    path: "buff-play/transactions",
    body: { ...data, metadata: {} },
  })
}

export const putHasFraudActivityBuffPlay = async(accountId: string, hasFraudActivity: boolean) => {
  return apiCall({
    method: "PUT",
    path: `buff-play/balances/has-fraud-activity/${accountId}`,
    body: { hasFraudActivity },
  })
}

export const putFaceVerificationBuffPlay = async(accountId: string, isFaceVerified: boolean) => {
  return apiCall({
    method: "PUT",
    path: `buff-play/accounts/face-verification/${accountId}`,
    body: { isFaceVerified },
  })
}

export const putWhitelistedBuffPlay = async(accountId: string, isWhitelisted: boolean) => {
  return apiCall({
    method: "PUT",
    path: `buff-play/accounts/whitelist/${accountId}`,
    body: { isWhitelisted },
  })
}

export const getAvailableGamesBuffPlay = async(
  accountId: string,
  page: number,
  limit: number,
  name: string,
  filter: AccountAvailableGamesFilterBuffPlay,
) => {
  const query: {
    accountId: string;
    page?: number;
    limit?: number;
    name?: string;
    source?: string;
  } = { limit, accountId, page, name }
  if (filter && filter.source) query.source = filter.source

  return apiCall({
    method: "GET",
    path: "buff-play/games",
    query: {
      accountId: query.accountId,
      page: query.page,
      limit: query.limit,
      ...(query.name && { name: query.name }),
      ...(query.source && { gameSource: query.source }),
    },
  })
}

export const completeGameTaskBuffPlay = async(
  accountId: string,
  gameId: string,
  taskId: string,
  platform: string,
  reward: number,
  taskName: string,
  taskType: string,
  rewardUsd?: number | null,
  status?: string,
) => {
  return apiCall({
    method: "POST",
    path: `buff-play/games/${gameId}/tasks/${taskId}/complete`,
    body: {
      accountId,
      platform,
      reward,
      ...(rewardUsd != null && { rewardUsd }),
      taskName,
      taskType,
      ...(status && { status }),
    },
  })
}

export const installGameBuffPlay = async(
  accountId: string,
  gameId: string,
  platform: string,
) => {
  return apiCall({
    method: "POST",
    path: `buff-play/games/${gameId}/install`,
    body: { accountId, platform },
  })
}

export const resetGameTasksBuffPlay = async(
  accountId: string,
  gameId: string,
  platform: string,
) => {
  return apiCall({
    method: "POST",
    path: `buff-play/games/${gameId}/reset-tasks`,
    body: { accountId, platform },
  })
}

export const deleteFingerprintBuffPlay = async(accountId: string) => {
  return apiCall({
    method: "DELETE",
    path: `buff-play/accounts/fingerprint/${accountId}`,
  })
}

